import { SearchKnownAction } from "./types";
import { AppThunkAction } from "../appThunkAction";
import hubService from "../../api/services/hub";

export const searchContent = (
  term: string,
  type: string,
  sort: string
): AppThunkAction<SearchKnownAction> => async (dispatch) => {
  dispatch({
    type: "SEARCH_REQUEST",
    term,
  });
  const data = await hubService.searchContent(term, type, sort);
  if (data.hasErrors) {
    dispatch({
      type: "SEARCH_REQUEST_FAIL",
      error: {
        message: data.errors[0],
        status: (data.value as any).status,
      },
    });
    return;
  }
  dispatch({
    type: "SEARCH_REQUEST_SUCCESS",
    payload: data.value,
  });
};

export const selectContent = (
  id: number
): AppThunkAction<SearchKnownAction> => async (dispatch) => {
  dispatch({
    type: "SEARCH_SELECT_FILE",
    fileId: id,
  });
};
